export default __webpack_public_path__ + "static/media/banner_6.873ad4a7.jpg";